import { render, staticRenderFns } from "./AdminTracker.vue?vue&type=template&id=5a1712a4&scoped=true&"
import script from "./AdminTracker.vue?vue&type=script&lang=js&"
export * from "./AdminTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1712a4",
  null
  
)

export default component.exports